<div class="relative w-full">
  <nz-card class="m-4 p-2">
    <div class="text-center m-2">
      <div class="hdr-ttl grd-hdr">{{ title }}</div>
    </div>
    <div>
      <div>
        @if (data.anlytcs_crd_json.length) {
        <div class="text-right">
          <span
            class="hd-anlt"
            (click)="settings.shw_anlytc = !settings.shw_anlytc"
          >
            @if (!settings.shw_anlytc) {
            <span>Show</span>
            } @if (settings.shw_anlytc) {
            <span>Hide</span>
            }analytics
          </span>
        </div>
        } @if (settings.shw_anlytc) {
        <div>
          <nz-card class="example-card" appearance="outlined">
            <div>
              <div class="grid grid-flow-col auto-cols-max gap-2">
                @for (a of data.anlytcs_crd_json; track a) {
                <div>
                  <ng-container>
                    <div>
                      <div class="flex-auto">
                        <div class="w-full h-full">
                          <span class="hdr-ttl"> {{ a.crd_hdr_nm }}</span>
                        </div>
                      </div>
                    </div>
                    <div>
                      <div class="grid grid-flow-col auto-cols-max gap-2">
                        @for (c of a.crd_val; track c) {
                        <div
                          class="crd-dv flex items-center justify-between rounded-xl px-1 py-8 dark:bg-white dark:bg-opacity-5 dark:text-indigo-400 fst_bgrnd sqft_1_bfre"
                        >
                          <div class="cnt-crd">
                            <div
                              class="text-2xl font-semibold leading-none tracking-tight sm:text-4xl pl-4"
                            >
                              <span
                                [ngClass]="
                                  c.fltr_typ == 'group_count'
                                    ? 'crsr-alwd'
                                    : 'crsr-nt-alwd crd-cnt-nrml-clr'
                                "
                                (click)="
                                  c.fltr_typ == 'group_count'
                                    ? fltrDataGrd(c, null)
                                    : ''
                                "
                              >
                                <span
                                  [ngClass]="
                                    c.crd_hghlt_in == true
                                      ? 'crd-cnt-hglt-clr'
                                      : 'crd-cnt-nrml-clr'
                                  "
                                >
                                  {{ c.cnt_val }}
                                </span>
                              </span>
                            </div>
                            <div class="mt-1 font-medium pl-4 cnt-ttl">
                              {{ c.title }}
                            </div>
                          </div>
                          @if (c.sb_anltc_cnts && c.sb_anltc_cnts.length) { @for
                          (sc of c.sb_anltc_cnts; track sc) {
                          <div class="cnt-crd">
                            <div
                              class="text-2xl font-semibold leading-none tracking-tight sm:text-4xl pl-4"
                            >
                              <span
                                [ngClass]="
                                  sc.fltr_typ == 'group_count'
                                    ? 'crsr-alwd'
                                    : 'crsr-nt-alwd'
                                "
                                (click)="
                                  sc.fltr_typ == 'group_count'
                                    ? fltrDataGrd(c, sc)
                                    : ''
                                "
                              >
                                <span
                                  [ngClass]="
                                    sc.crd_hghlt_in == true
                                      ? 'crd-cnt-hglt-clr'
                                      : 'crd-cnt-nrml-clr'
                                  "
                                >
                                  {{ sc.cnt_val }}</span
                                >
                              </span>
                            </div>
                            <div class="mt-1 font-medium pl-4 cnt-ttl">
                              {{ sc.title }}
                            </div>
                          </div>
                          } }
                          <div>
                            <div class="crdIcn2">
                              <!-- <mat-icon svgIcon="equalizer"></mat-icon> -->
                              <span
                                nz-icon
                                nzType="bar-chart"
                                nzTheme="outline"
                              ></span>
                            </div>
                          </div>
                        </div>
                        }
                      </div>
                    </div>
                  </ng-container>
                </div>
                } @for (g of data.anlytcs_grph_json; track g) {
                <div class="flex">
                  <div class="flex">
                    <div>
                      <div class="cstm_chart">
                        <div>
                          <span class="hdr-ttl">
                            {{ g.chartOptions.title }}</span
                          >
                        </div>
                        <app-chart [options]="g.chartOptions"></app-chart>
                      </div>
                    </div>
                  </div>
                </div>
                }
              </div>
            </div>
          </nz-card>
        </div>
        }
      </div>

      <div>
        <!-- records counts -->

        <div class="mt-4 flex">
          <div>
            <!-- <span *ngIf="settings.fltr_apld_rst_btn_in" matTooltip="Reset data" class="cursor-pointer"
            (click)="clrGrdFltrs()"> <mat-icon svgIcon="restart_alt"></mat-icon> </span> -->

            @if (settings.fltr_apld_rst_btn_in) {
            <span
              class="cursor-pointer"
              (click)="clrGrdFltrs()"
              nz-icon
              nzType="reload"
              nzTheme="outline"
            ></span>
            }
          </div>
          <div>
            <span class="dv-ttl-rc-lbl">Total Records :</span>
            <span class="dv-ttl-rc-vl">
              {{ dataSource && dataSource.length }}</span
            >
          </div>
          @if (enableMultiSelect) {
          <div class="pl-8">
            <span class="dv-ttl-rc-lbl">Selected Records :</span>
            <span class="dv-ttl-rc-vl"> {{ data.grdSlctdRws.length }}</span>
          </div>
          }
        </div>

        <!-- grid -->
        <!-- class="ds-card grid" -->
        <!-- (onExporting)="onExporting($event)" -->
        <div>
          <app-data-grid
            id="DxDataGridComponent"
            style="width: 100%"
            [dataSource]="dataSource"
            [pagingEnabled]="settings.shw_pg_sz"
            [pageSize]="settings.pg_sz"
            [allowedPageSizes]="settings.pg_sz_arry"
            [showPageSizeSelector]="true"
            [selectionMode]="enableMultiSelect ? 'multiple' : 'none'"
            [columnChooser]="true"
            [allowExport]="settings.fltr_grp_pnl_enbl"
            [exportFileName]="settings.exprt_fl_nm"
            [searchPanel]="settings.fltr_grp_pnl_enbl"
            [filterPanel]="settings.fltr_grp_pnl_enbl"
            [groupPanel]="settings.fltr_grp_pnl_enbl"
            [filterRow]="settings.fltr_grp_pnl_enbl"
            [headerFilter]="settings.fltr_grp_pnl_enbl"
            [toolbarItems]="gridToolbarItems"
            [totalItems]="gridTotalItems"
            [rowAlternationEnabled]="true"
            [showBorders]="true"
            (cellClick)="onCellClick($event)"
            (selectionChanged)="selectionChanged($event)"
          >
            <!-- Row action buttons: one column per configured button.
        The button markup is ONE shared cell template that reads its
        button from `column.meta`. The template cannot live inside the
        *ngFor - the grid finds cell templates with @ContentChildren
        (descendants: false), which does not look into embedded views,
        so a template nested in an *ngFor would never be found and every
        action cell would render blank. -->
            @for (b of settings.row_buttons; track b) {
            <app-grid-column
              [showInColumnChooser]="false"
              [visible]="true"
              [type]="b.btn_id"
              [meta]="b"
              [width]="b.width ? b.width : b.btn_type == 'button' ? 130 : 70"
              cellTemplate="cstmRowBtn"
              [alignment]="'center'"
              [caption]="b.btn_type == 'icon' ? b.label : ''"
            ></app-grid-column>
            }

            <ng-template
              appGridCell="cstmRowBtn"
              let-data="cell"
              let-col="column"
            >
              <div>
                @if (col.meta.btn_type == 'button') {
                <button
                  nz-button
                  nzType="default"
                  [ngClass]="col.meta.color"
                  class="dv-cstm-btn"
                  (click)="onRowBtnClkEvnt(data.data, col.meta)"
                >
                  @if (col.meta.icon) {
                  <i nz-icon [nzType]="col.meta.icon" class="btn-icn"></i>
                  }
                  {{ col.meta.label }}
                </button>
                } @if (col.meta.btn_type == 'icon') {
                <button
                  class="eyeicnbtn"
                  (click)="onRowBtnClkEvnt(data.data, col.meta)"
                >
                  <i nz-icon [nzType]="col.meta.icon"></i>
                </button>
                }
              </div>
            </ng-template>

            @for (c of colDef; track c) {
            <app-grid-column
              [visible]="c.visible"
              [dataField]="c.field"
              [caption]="c.headerName"
              [width]="c.width"
              [alignment]="c.alignment"
              [allowResizing]="true"
              [allowFiltering]="c.filter"
              [allowSearch]="c.filter"
              [allowHiding]="true"
              [allowGrouping]="c.allowGrouping"
              [format]="
                c.crncy_in == true
                  ? {
                      style: 'currency',
                      currency: 'INR',
                      useGrouping: true,
                      minimumSignificantDigits: 4
                    }
                  : ''
              "
              [allowHeaderFiltering]="c.allowHeaderFiltering"
            >
              @if (c.subClmns) { @for (l2 of c.subClmns; track l2) {
              <app-grid-column
                [visible]="l2.visible"
                [dataField]="l2.field"
                [caption]="l2.headerName"
                [width]="l2.width"
                [alignment]="l2.alignment"
                [allowResizing]="true"
                [allowFiltering]="l2.filter"
                [allowHeaderFiltering]="l2.allowHeaderFiltering"
                [allowGrouping]="l2.allowGrouping"
              >
                @if (l2.subClmns) { @for (l3 of l2.subClmns; track l3) {
                <app-grid-column
                  [visible]="l3.visible"
                  [dataField]="l3.field"
                  [caption]="l3.headerName"
                  [width]="l3.width"
                  [alignment]="l3.alignment"
                  [allowResizing]="true"
                  [allowFiltering]="l3.filter"
                  [allowHeaderFiltering]="l3.allowHeaderFiltering"
                  [allowGrouping]="l3.allowGrouping"
                >
                  @if (l3.subClmns) { @for (l4 of l3.subClmns; track l4) {
                  <app-grid-column
                    [visible]="l4.visible"
                    [dataField]="l4.field"
                    [caption]="l4.headerName"
                    [width]="l4.width"
                    [alignment]="l4.alignment"
                    [allowResizing]="true"
                    [allowFiltering]="l4.filter"
                    [allowHeaderFiltering]="l4.allowHeaderFiltering"
                    [allowGrouping]="l4.allowGrouping"
                  >
                    @if (l4.subClmns) { @for (l5 of l4.subClmns; track l5) {
                    <app-grid-column
                      [visible]="l5.visible"
                      [dataField]="l5.field"
                      [caption]="l5.headerName"
                      [width]="l5.width"
                      [alignment]="l5.alignment"
                      [allowResizing]="true"
                      [allowFiltering]="l5.filter"
                      [allowHeaderFiltering]="l5.allowHeaderFiltering"
                      [allowGrouping]="l5.allowGrouping"
                    >
                      @if (l5.subClmns) { @for (l6 of l5.subClmns; track l6) {
                      <app-grid-column
                        [visible]="l6.visible"
                        [dataField]="l6.field"
                        [caption]="l6.headerName"
                        [width]="l6.width"
                        [alignment]="l6.alignment"
                        [allowResizing]="true"
                        [allowFiltering]="l6.filter"
                        [allowHeaderFiltering]="l6.allowHeaderFiltering"
                        [allowGrouping]="l6.allowGrouping"
                      >
                      </app-grid-column>
                      } }
                    </app-grid-column>
                    } }
                  </app-grid-column>
                  } }
                </app-grid-column>
                } }
              </app-grid-column>
              } }
            </app-grid-column>
            }
          </app-data-grid>
        </div>
      </div>
    </div>
  </nz-card>

  <!-- dailouge box -->
  <!-- <ng-template #gridDialogContent>
<h2 mat-dialog-title>Alert!</h2>
<mat-dialog-content>
  <div>
    <div>
      {{settings.dlg_stngs.alrt_bdy_msg}}
    </div>

  </div>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button *ngFor="let b of settings.dlg_stngs.alrt_bx_btns" mat-flat-button [color]="b.color" class="m-4"
  style="color: rgb(255, 255, 255);" (click)="onBtnClick(b.cb_res_cd)">{{b.label}}</button>
</mat-dialog-actions>
</ng-template> -->

  <!-- <nz-modal [(nzVisible)]="isVisible" nzTitle="Custom Modal Title" (nzOnCancel)="handleCancel()">
<div *nzModalContent>
  <p>{{settings.dlg_stngs.alrt_bdy_msg}}</p>
</div>
<div *nzModalFooter>
  <span>Modal Footer:</span>
  <button *ngFor="let b of settings.dlg_stngs.alrt_bx_btns" [ngStyle]="{ 'color': b.color }" class="m-4"
  style="color: rgb(255, 255, 255);" (click)="onBtnClick(b.cb_res_cd)">{{b.label}}</button>
</div>
</nz-modal> -->
</div>

@if (data.dmyChrt) {
<div class="dmy-chrt">
  <app-chart [options]="data.dmyChrt"></app-chart>
</div>
}
